import { useEffect } from 'react';

import { usePathname } from 'expo-router';
import { useStoreContext } from 'features/store';

import { usePrevious } from 'hooks/use-previous';
import { getStaticPathAndSearch } from 'navigation/location/location';
import { logPageView } from 'state/amplitude';
import { BranchEventNames } from 'state/branch/branch-event-names';
import { logBranchEvent } from 'state/branch/utils';

import { logFirebasePageView } from './log-firebase-page-view';

// This functions receives a string like: /path?query=param and returns the query
// parameters as string
const getQueryParams = (path: string | undefined): string | undefined => {
  const query = path?.split('?')[1];
  return query;
};

// Only used for react-router and WEB
export default function useLogPageView() {
  const pathname = usePathname();
  const previousPathname = usePrevious(pathname);
  const { store } = useStoreContext();

  // uncomment to debug router state
  //useDebugLogRouterState();
  useEffect(() => {
    if (previousPathname !== pathname) {
      logPageView(pathname, store, getQueryParams(getStaticPathAndSearch()));
      logFirebasePageView(pathname);
      logBranchEvent(BranchEventNames.PAGE_VIEW);
      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.log('PATH:', getStaticPathAndSearch());
      }
    }
  }, [pathname, store, previousPathname]);
}
